import axios from 'axios';

export const getFilesList = () => axios.get('/files/platform_list/');
